import axifyDefault from "./axifyDefault.json";
import boathouse from "./boathouse.json";

// Registry of client themes. Add a new client by dropping a JSON file in this
// folder and registering it here — no component code changes required.
const themes = {
  axifyDefault,
  boathouse,
};

export const DEFAULT_THEME_NAME = "axifyDefault";

export function getTheme(name) {
  if (name && themes[name]) {
    return themes[name];
  }
  return themes[DEFAULT_THEME_NAME];
}

export default themes;
